import { FC } from "react";
import { MuiModal } from "../../../../components/modal/MuiModal";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { MuiTypography } from "../../../../components/typography/MuiTypography";
import { keyProjectDetailsSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { CreateProjectInformationWrapper } from "../../CreateProject.style";

interface CreateProjectInformationModalProps {
  showModal: boolean;
  handleModalClose: () => void;
  handlePrimaryButtonClick: () => void;
}
export const CreateProjectInformationModal: FC<
  CreateProjectInformationModalProps
> = ({ handleModalClose, showModal, handlePrimaryButtonClick }) => {
  const { commonLabels, fetchLabel } = useSiteCore();
  return (
    <MuiModal
      open={showModal}
      onClose={handleModalClose}
      title={commonLabels.information}
      primaryButtonTitle={commonLabels.ok}
      onPrimaryButtonClick={handlePrimaryButtonClick}
    >
      <CreateProjectInformationWrapper>
        <MuiTypography
          id="modal-description"
          variant="h3"
          className="confirm-message"
        >
          {fetchLabel(
            keyProjectDetailsSiteCoreKeys.keyProjectDetails,
            keyProjectDetailsSiteCoreKeys.allTheActivitiesAndDeliverablesThatAreAssociatedToTheSelectedProjectFramework,
          )}
        </MuiTypography>
      </CreateProjectInformationWrapper>
    </MuiModal>
  );
};
